/* KitKraft — blog article enhancements:
   1. "Add all parts to cart" button (data-kk-add-all="id,id,id")
   2. click-to-zoom on article images (featured + in-content) via Fancybox
*/
(() => {
  "use strict";

  /* ---- 1. add-all-to-cart ---- */
  function bindAddAll() {
    document.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-kk-add-all]");
      if (!btn) return;
      e.preventDefault();
      const ids = (btn.dataset.kkAddAll || "")
        .split(",")
        .map((s) => parseInt(s.trim(), 10))
        .filter((n) => n > 0);
      if (!ids.length) return;

      const original = btn.textContent;
      btn.setAttribute("disabled", "");
      // KitKraft 2026-09-23: this button does 2 sequential fetches then a full page
      // navigation to /cart — on a slow mobile connection that's several seconds of
      // silence, which Clarity showed as a real dead-click spike (users tap again or
      // leave, reading the static "Adding…" text as stuck). A spinner that appears the
      // instant the tap registers, independent of network speed, fixes the *perception*
      // even though the actual wait time is unchanged.
      btn.classList.add("kk-parts__add--loading");
      btn.innerHTML = '<span class="kk-spinner" aria-hidden="true"></span><span>Adding…</span>';

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: ids.map((id) => ({ id, quantity: 1 })) })
      })
        .then((r) => r.json())
        .then((res) => {
          if (res && res.status && res.status >= 400) {
            throw new Error(res.description || "Could not add to cart");
          }
          return fetch("/cart.js").then((r) => r.json());
        })
        .then((cart) => {
          btn.classList.remove("kk-parts__add--loading");
          btn.textContent = "Added ✓";
          document.dispatchEvent(new CustomEvent("cart-change", { detail: cart }));
          // open the drawer/dropdown if the theme has one, else go to cart
          const drawerToggle = document.querySelector(".js-header-cart-icon--desktop, .js-mini-cart, [data-cart-toggle]");
          if (document.body.classList.contains("cart-type-page")) {
            window.location.href = "/cart";
          } else if (drawerToggle) {
            setTimeout(() => { try { drawerToggle.click(); } catch (err) {} }, 150);
            setTimeout(() => { btn.removeAttribute("disabled"); btn.textContent = original; }, 2500);
          } else {
            window.location.href = "/cart";
          }
        })
        .catch((err) => {
          btn.classList.remove("kk-parts__add--loading");
          btn.textContent = "Couldn't add — try the product pages";
          btn.removeAttribute("disabled");
          setTimeout(() => { btn.textContent = original; }, 3000);
          console.warn("[kk-blog] add-all failed:", err);
        });
    });
  }

  /* ---- 2. image zoom ---- */
  function zoomableImages() {
    const list = [];
    const featured = document.querySelector(".article-template_featured-image-tag");
    if (featured) list.push(featured);
    const content = document.querySelector(".article-template_content, .rte");
    if (content) {
      content.querySelectorAll("img").forEach((img) => {
        if (img.closest("a")) return;                 // already a link
        const w = img.naturalWidth || img.width || 0;
        if (w && w < 150) return;                      // icon / emoji-sized
        list.push(img);
      });
    }
    return list;
  }

  function bindImageZoom() {
    const imgs = zoomableImages();
    if (!imgs.length) return;
    imgs.forEach((img) => {
      if (img.dataset.kkZoom) return;
      img.dataset.kkZoom = "1";
      img.style.cursor = "zoom-in";
      img.addEventListener("click", (e) => {
        e.preventDefault();
        if (!window.Fancybox) return;
        const all = zoomableImages();
        const slides = all.map((el) => ({ src: el.currentSrc || el.src, caption: el.alt || "" }));
        window.Fancybox.show(slides, { startIndex: Math.max(0, all.indexOf(img)), Hash: false });
      });
    });
  }

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn, { once: true });
  }

  bindAddAll();
  ready(bindImageZoom);
  window.addEventListener("load", bindImageZoom, { once: true });
})();
